import { type StoreActionApi } from 'react-sweet-state';

import { STARTING_PROGRESS } from './STARTING_PROGRESS';
import type { ChatMessageResearchStore } from './types';

type InitResearchMessageArgs = { messageId: string };

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const initResearchMessage: (
	args: InitResearchMessageArgs,
) => ChatMessageResearchStoreAction =
	({ messageId }: { messageId: string }) =>
	({ getState, setState }: StoreActionApi<ChatMessageResearchStore>) => {
		const message = getState()[messageId];
		if (!message) {
			setState({
				[messageId]: { currentProgress: STARTING_PROGRESS, steps: {}, researchPlans: {} },
			});
		}
	};
